import styled from 'styled-components'

export const Container = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  margin-top: 4px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const Label = styled.span`
  color: #115850;
  font-weight: 400;
`

export const Value = styled.span`
  color: #115850;
  font-weight: 400;
  text-align: right;
`

export const PayersContainer = styled.div`
  margin-top: 4px;
  padding: 6px 8px;
  background: #f4f9f8;
  border-radius: 4px;
  font-size: 12px;
`

export const PayersTitle = styled.p`
  font-weight: 600;
  color: #115850;
  margin-bottom: 4px;
`

export const PayerRow = styled.div`
  display: flex;
  justify-content: space-between;
  color: #444;
`
